module.exports = __webpack_public_path__ + "sunsemweb/img/ori.1033fad9.png";